var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoordinateIcon = function SvgCoordinateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CC0C1C",
    d: "M8.004 27.437c.22-.47.69-.769 1.208-.769h21.576c.518 0 .988.3 1.208.769l3.117 6.666a1.333 1.333 0 0 1-1.208 1.898H6.095a1.333 1.333 0 0 1-1.208-1.898z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M8.39 13.553c0-6.413 5.2-11.612 11.612-11.612 6.398 0 11.588 5.176 11.61 11.568l.002.044c0 5.92-3.841 11.31-10.192 15.954a2.41 2.41 0 0 1-2.84 0C12.322 24.928 8.5 19.625 8.393 13.802z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.002 9.273a4.278 4.278 0 1 0 0 8.556 4.278 4.278 0 0 0 0-8.556"
  })));
};
export default SvgCoordinateIcon;